import corperateaffair from "./corporate-affairs";
import directTax from "./direct-tax";
import incomeTax from "./income-tax";
import indirectTax from "./indirect-tax";
import internationalTaxation from "./International-taxation";
import { IKnowledgeCard, IKnowledgeSection } from "./types";

/**
 * ---------------------------------------------------------------------------
 * HOW TO ADD A SECTION — 2 steps, nothing else in the app needs changing.
 *
 * 1. Copy ./income-tax.ts to ./your-section.ts and edit the five fields in it:
 *      key    unique, e.g. "gst"
 *      title  side bar label, e.g. "GST"
 *      icon   an image exported from "assets"
 *      color  its own colour, so its cards stand out in the "All" view
 *      links  { title, href } for every card
 *
 * 2. Import it below and add it to the array.
 *
 * The side bar item, its cards, and its share of the "All" view all follow
 * from that. No JSX to write and no other file to open.
 * ---------------------------------------------------------------------------
 */
export const knowledgeSections: Array<IKnowledgeSection> = [
  directTax,
  internationalTaxation,
  indirectTax,
  corperateaffair,
  // 👇 add your new section here
];

// Every section's links in one list — this is the "All" view. Each card keeps
// its section's name and colour, so the tag tells you where a card came from.
// A href that two sections happen to share is kept once, so "All" never repeats
// a card — the tag then shows whichever section listed it first. Cards are
// sorted alphabetically by title, independent of section order.
export const allCards: Array<IKnowledgeCard> = Array.from(
  knowledgeSections
    .flatMap((section) =>
      section.links.map((link) => ({ ...link, label: section.title, color: section.color })),
    )
    .reduce(
      (byHref, card) => (byHref.has(card.href) ? byHref : byHref.set(card.href, card)),
      new Map<string, IKnowledgeCard>(),
    )
    .values(),
).sort((a, b) => a.title.localeCompare(b.title, undefined, { sensitivity: "base" }));

export { default as SectionGrid } from "./SectionGrid";
export * from "./types";
